import axios from "axios";
import { baseUrl } from "./Constants";
import { processAndUpdateToken } from "./CommonFunctions";

export const quoteCompareTblsData = [
  {
    HeaderID: "11",
    JOBID: " ",
    Headers: "Named Insured",
    "": "",
  },
  {
    HeaderID: "21",
    JOBID: " ",
    Headers: "Term",
    "": "",
  },
  {
    HeaderID: "31",
    JOBID: " ",
    Headers: "LOB",
    "": "",
  },
  {
    HeaderID: "41",
    JOBID: " ",
    Headers: "Pol#",
    "": "",
  },
  {
    HeaderID: "51",
    JOBID: " ",
    Headers: "Carrier Name",
    "": "",
  },
  {
    HeaderID: "61",
    JOBID: " ",
    Headers: "Account Manager",
    "": " ",
  },
  {
    HeaderID: "71",
    JOBID: " ",
    Headers: "Checked by",
    "": "",
  },
  {
    HeaderID: "81",
    JOBID: " ",
    Headers: "Checked on",
    "": "",
  },
  {
    HeaderID: "91",
    JOBID: " ",
    Headers: "Documents used for policy review",
    "": "",
  },
];

export const GetAllJobInfo = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/QuoteCompare/GetAllBrokerQCJobs",
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetJobInfo = async (brokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/QuoteCompare/GetJobs?brokerId=" + brokerId,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};
export const GetDiscrepancyInfo = async (brokerId, JobId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        "/api/QuoteCompare/GetDiscrepancrJobs?brokerId=" +
        brokerId +
        "&jobId=" +
        JobId,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};
export const GetBrokerList = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/Defaultdatum/GetBrokerNames/GetBrokerNames",
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetTbl1Data = async (BrokerId, JobId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetJobInfo?brokerid=${BrokerId}&jobid=${JobId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetJobFiles = async (JobId, BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetJobFiles?JobId=${JobId}&brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetJobQCData = async (Id, BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + `/api/QuoteCompare/GetJobData?id=${Id}&brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetLobQuestionsByJobId = async (Id, BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetLobQuestionsByJobId?id=${Id}&brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetLobQuestionsByLobId = async (Id, BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetLobQuestionsByLobId?id=${Id}&brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetLobsByBrokerId = async (BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + `/api/QuoteCompare/GetLobsByBrokerId?brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetChecklistQuestionsByBrokerId = async (BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetChecklistQuestionsByBrokerId?brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetCoverageSpecificationsByBrokerId = async (BrokerId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetCoverageSpecificationsByBrokerId?brokerId=${BrokerId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetFileName = async (JobId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + `/api/QuoteCompare/GetFileName?jobid=${JobId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const GetLobDetailsForQuoteCompare = async (brokerId, JobId) => {
  try {
    const token = sessionStorage.getItem("token");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        `/api/QuoteCompare/GetLobDetailsForQuoteCompare?brokerId=${brokerId}&jobId=${JobId}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    return "failed";
  }
};

export const UpdateQcStatusCall = async (data, token) => {
  try {
    const Token = await processAndUpdateToken(token);
    const user = sessionStorage.getItem("csrAuthUserName");

    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };

    // Make the PUT request
    const response = await axios.put(
      baseUrl + "/api/QuoteCompare/UpdateQcStatus",
      data,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      return "failed";
    }
    if (response?.data) {
      return response.data;
    } else {
      return "failed";
    }
  } catch (error) {
    console.error("Error updating job preview status:", error);
    // Optionally, handle the error appropriately
  }
};

export const GetCheckListQuestionMasterData = async (token, jobId) => {
  const LobSplitMasterKeys = sessionStorage.getItem(
    "QuoteLobSplitQuestionData",
  );
  if (LobSplitMasterKeys && LobSplitMasterKeys?.length > 0) {
    return LobSplitMasterKeys;
  } else {
    return await SetCheckListQuestionMasterData(token, jobId);
  }
};

export const SetCheckListQuestionMasterData = async (token, jobId) => {
  try {
    sessionStorage.removeItem("QuoteLobSplitQuestionData");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl +
        "/api/Defaultdatum/GetCheckListQuestionMasterData?jobId=" +
        jobId,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    sessionStorage.setItem(
      "QuoteLobSplitQuestionData",
      response?.data?.length > 0
        ? JSON.stringify(response?.data)
        : response?.data,
    );
    return response?.data;
  } catch (error) {
    //error happened block
  }
};

export const getLOBSplitMasterKeys = async (token) => {
  const LobSplitMasterKeys = sessionStorage.getItem("QuoteLobSplitMasterKeys");
  if (LobSplitMasterKeys && LobSplitMasterKeys?.length > 0) {
    return LobSplitMasterKeys;
  } else {
    return await setLOBSplitMasterKeys(token);
  }
};

export const mapLOBColumns = async (dataSet, token, jobId, fileState) => {
  let LobSplitMasterKeys = await getLOBSplitMasterKeys(token);
  LobSplitMasterKeys = LobSplitMasterKeys
    ? Array.isArray(LobSplitMasterKeys)
      ? LobSplitMasterKeys
      : JSON.parse(LobSplitMasterKeys)
    : [];
  let mappedData = dataSet;
  let QuoteLobMasterData = await getQuoteLobMasterData(token, Number(jobId?.substring(0,4)));

  if (mappedData && mappedData?.length > 0) {
    mappedData = mappedData.map((e) => {
      let findLOBName = LobSplitMasterKeys?.find(
        (f) =>
          f?.CHECKLIST_LOB_CODE?.toLowerCase()?.trim() ==
          e["QLob"]?.toLowerCase()?.trim(),
      );
      if (findLOBName) {
        e["PolicyLob"] = findLOBName?.Checklist_LOB_Master;
      }
      return e;
    });
  }

  if (QuoteLobMasterData && QuoteLobMasterData?.length > 0) {
    mappedData = mappedData?.map((e) => {
      if(e["QLob"] != null) {
        let findPolicyLOBName = QuoteLobMasterData?.find(
          (f) =>
            f?.LOB?.toLowerCase()?.trim() ==
            e["PolicyLob"]?.toLowerCase()?.trim(),
        );

         if (!findPolicyLOBName) {
            findPolicyLOBName = QuoteLobMasterData?.find((f) => {
                let lobText = f?.LOB?.toLowerCase()?.trim()?.split("(")[0] ?.trim();
                return e["PolicyLob"]?.toLowerCase()?.trim()?.startsWith(lobText);
            });
          }

        if (findPolicyLOBName) {
          e["QLob"] = findPolicyLOBName?.LobCode;
        }
      }
      return e;
    });
  }
  
  //below code is mandatory --by gokul
  let checklistQuestionMaster = [
    {
      LobId: 2,
      LobName:
        "Cargo/Transportation/Contingent/Ocean Cargo/Warehouse Legal Liability ",
      LobCode: "proc",
      Question: "Limit",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 2,
      LobName:
        "Cargo/Transportation/Contingent/Ocean Cargo/Warehouse Legal Liability ",
      LobCode: "proc",
      Question: "Deductible",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 2,
      LobName:
        "Cargo/Transportation/Contingent/Ocean Cargo/Warehouse Legal Liability ",
      LobCode: "proc",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 2,
      LobName:
        "Cargo/Transportation/Contingent/Ocean Cargo/Warehouse Legal Liability ",
      LobCode: "proc",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
    {
      LobId: 2,
      LobName:
        "Cargo/Transportation/Contingent/Ocean Cargo/Warehouse Legal Liability ",
      LobCode: "proc",
      Question: "Scheduled Equipment/Unscheduled Equipment",
      CheckListQuestion:
        "EQ1:Scheduled/ Unscheduled Equipment and Warranties of any kind?",
      ShortQuestion: "EQ1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Coverage/Limits (incl. cost new)",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Deductibles (incl. Comprehensive &/or Collision)",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Vehicle Schedule (VIN numbers)",
      CheckListQuestion: "AS1:Correct Autos on the Schedule?",
      ShortQuestion: "AS1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Symbols",
      CheckListQuestion: "AD1:Correct Covered Auto Designation/symbols?",
      ShortQuestion: "AD1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Drive Other Car",
      CheckListQuestion:
        "DOC:If there is Driver Other Car (DOC) coverage, is the listing of covered individuals correct?",
      ShortQuestion: "DOC",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Composite Rating",
      CheckListQuestion:
        "CV1:Does the Policy shows composite rating or Per Schedule on File w/Carrier?",
      ShortQuestion: "CV1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
    {
      LobId: 3,
      LobName: "Commercial Auto/Truckers/Contingent/Garage",
      LobCode: "gatr",
      Question: "Excluded Driver",
      CheckListQuestion: "DEX:Is “Drivers are excluded” listed on the policy?",
      ShortQuestion: "DEX",
    },
    {
      LobId: 6,
      LobName: "Cyber",
      LobCode: "cgcy",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 6,
      LobName: "Cyber",
      LobCode: "cgcy",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 6,
      LobName: "Cyber",
      LobCode: "cgcy",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 6,
      LobName: "Cyber",
      LobCode: "cgcy",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 6,
      LobName: "Cyber",
      LobCode: "cgcy",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question: "Retentions",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question: "Countries Not Allowed / Excluded",
      CheckListQuestion: "CT1:Is Coverage Territory Correct as proposed?",
      ShortQuestion: "CT1",
    },
    {
      LobId: 9,
      LobName: "Employment Practices (EPL)",
      LobCode: "cgep",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question: "Countries Not Allowed / Excluded",
      CheckListQuestion: "CT1:Is Coverage Territory Correct as proposed?",
      ShortQuestion: "CT1",
    },
    {
      LobId: 12,
      LobName: "Executive Protection Liability/Executive Risk",
      LobCode: "exmg",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 14,
      LobName: "Foreign Coverage",
      LobCode: "bofp",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 14,
      LobName: "Foreign Coverage",
      LobCode: "bofp",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 14,
      LobName: "Foreign Coverage",
      LobCode: "bofp",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question: "Coverage/Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question:
        "Exposures (Class Code, Sales/Payroll/Area/Unit/Other) and Composite Rating",
      CheckListQuestion:
        "IE1:Correct Inception Exposure Basis,Rates, Class codes, Experience modifier, Payrolls and Composite rating?",
      ShortQuestion: "IE1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
    {
      LobId: 15,
      LobName: "General Liability",
      LobCode: "cgll",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question: "Loss Sustained/Loss Discovered",
      CheckListQuestion: "LD1:Loss Sustained & Loss Discovered?",
      ShortQuestion: "LD1",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question: "Deductible",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 18,
      LobName: "Other Miscellaneous Liability",
      LobCode: "cgac",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 21,
      LobName: "Property",
      LobCode: "PRPP",
      Question: "Main Coverage/Limits (BLDG / BI / BPP)",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 21,
      LobName: "Property",
      LobCode: "PRPP",
      Question: "Deductibles (Incl basis: flat/hour/percentage etc.)",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 21,
      LobName: "Property",
      LobCode: "PRPP",
      Question: "Coinsurance/Agreed Value/Valuation",
      CheckListQuestion:
        "AV1:Valuation, Agreed Value or Coinsurance % as Proposed?",
      ShortQuestion: "AV1",
    },
    {
      LobId: 21,
      LobName: "Property",
      LobCode: "PRPP",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "Coverage/Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "Underlying Limits (Limits Only)",
      CheckListQuestion: "ULM:Correct Underlying Schedule of Limits?",
      ShortQuestion: "ULM",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "SIR/Deductible",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 22,
      LobName: "Umbrella/Excess",
      LobCode: "umbr",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Part 1 - State",
      CheckListQuestion:
        "SC1:Do the States covered by the Policy match with the Proposal -Item 3A?",
      ShortQuestion: "SC1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Part 2 - Employer’s Liab Limit",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Part 3 - Other States (List States in Comments)",
      CheckListQuestion:
        "SE1:Are Other States (except Monopolistic States) covered as Proposed-Item 3C?",
      ShortQuestion: "SE1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Deductible",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question:
        "Exposure (Class Code, Classification, Payroll. etc) &Experience/Merit Mod",
      CheckListQuestion:
        "IE1:Correct Inception Exposure Basis,Rates, Class codes, Experience modifier, Payrolls and Composite rating?",
      ShortQuestion: "IE1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Countries Not Allowed / Excluded",
      CheckListQuestion: "CT1:Is Coverage Territory Correct as proposed?",
      ShortQuestion: "CT1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "FEIN number",
      CheckListQuestion: "FN1:Correct FEIN number?",
      ShortQuestion: "FN1",
    },
    {
      LobId: 23,
      LobName: "Workers Compensation",
      LobCode: "work",
      Question: "Waiver of Subrogation (Including Blanket wording)",
      CheckListQuestion: "WS1",
      ShortQuestion: "WS1",
    },
    {
      LobId: 30,
      LobName:
        "Cyber E&O / Directors & Officers (D & O) / Fiduciary / Pollution Liability / Professional (E&O)",
      LobCode: "cgeo",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 30,
      LobName:
        "Cyber E&O / Directors & Officers (D & O) / Fiduciary / Pollution Liability / Professional (E&O)",
      LobCode: "cgeo",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 30,
      LobName:
        "Cyber E&O / Directors & Officers (D & O) / Fiduciary / Pollution Liability / Professional (E&O)",
      LobCode: "cgeo",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 30,
      LobName:
        "Cyber E&O / Directors & Officers (D & O) / Fiduciary / Pollution Liability / Professional (E&O)",
      LobCode: "cgeo",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 30,
      LobName:
        "Cyber E&O / Directors & Officers (D & O) / Fiduciary / Pollution Liability / Professional (E&O)",
      LobCode: "cgeo",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Retroactive Date",
      CheckListQuestion: "RD1:Correct Retroactive Date, if applicable?",
      ShortQuestion: "RD1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Continuity/Pending & Prior Litigation Date",
      CheckListQuestion:
        "PL1:Correct Pending & Prior Litigation Date, if applicable?",
      ShortQuestion: "PL1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Countries Not Allowed / Excluded",
      CheckListQuestion: "CT1:Is Coverage Territory Correct as proposed?",
      ShortQuestion: "CT1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Deductible",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question:
        "Additional Insured (s)/Waiver of Subrogation (Only if specific names mentioned)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 31,
      LobName: "Crime / Kidnap/Ransom (K&R)",
      LobCode: "prcr",
      Question: "Loss Sustained/Loss Discovered",
      CheckListQuestion: "LD1:Loss Sustained & Loss Discovered?",
      ShortQuestion: "LD1",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Limits",
      CheckListQuestion: "LMT:Correct Limits?",
      ShortQuestion: "LMT",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Deductibles",
      CheckListQuestion:
        "DE1:Correct Deductibles, Participation, or Retention Amounts?",
      ShortQuestion: "DE1",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Scheduled Equipment/Unscheduled Equipment",
      CheckListQuestion:
        "EQ1:Scheduled/ Unscheduled Equipment and Warranties of any kind?",
      ShortQuestion: "EQ1",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Coinsurance/Agreed Value/Valuation",
      CheckListQuestion:
        "AV1:Valuation, Agreed Value or Coinsurance % as Proposed?",
      ShortQuestion: "AV1",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Waiver of Subrogation (Including Blanket wording)",
      CheckListQuestion:
        "AI1:Correct Additional Insureds / Waiver of Subrogation  as Proposed (including individual and blanket)?",
      ShortQuestion: "AI1",
    },
    {
      LobId: 32,
      LobName:
        "Inland Marine / Builders Risk / Installation Floater / Rigging /Equipment Breakdown/Electronic Data Processing (EDP)",
      LobCode: "PRIM",
      Question: "Audit",
      CheckListQuestion: "AU1:Subject to Audit?",
      ShortQuestion: "AU1",
    },
  ];

  const mappedDataForUniquPolicyLob = mappedData.filter(
    (f) => f?.QLob != null && f?.QLob !== undefined && f?.QLob?.trim() !== "",
  );

  const policyLob = mappedDataForUniquPolicyLob.map((e) => e?.PolicyLob);
  const uniquePolicyLob = Array.from(new Set(policyLob));
  if (uniquePolicyLob?.length > 0) {
    uniquePolicyLob.forEach((f, index) => {
      let policyQuestionMaster = checklistQuestionMaster.filter(
        (item) => item?.LobName && item?.LobName == f,
      );

      if (QuoteLobMasterData && QuoteLobMasterData?.length > 0) {
        policyQuestionMaster = policyQuestionMaster?.map((e) => {
          if(e["LobCode"] != null) {
            let findPolicyLOBName = QuoteLobMasterData?.find(
              (f) =>
                f?.LOB?.toLowerCase() ==
                e["LobName"]?.toLowerCase()?.trim(),
            );

            if (!findPolicyLOBName) {
              findPolicyLOBName = QuoteLobMasterData?.find((f) => {
                  let lobText = f?.LOB?.toLowerCase()?.trim()?.split("(")[0] ?.trim();
                  return e["LobName"]?.toLowerCase()?.trim()?.startsWith(lobText);
              });
            }

            if (findPolicyLOBName) {
              e["LobCode"] = findPolicyLOBName?.LobCode;
            }
          }
          return e;
        });
      }

      if (policyQuestionMaster?.length > 0) {
        let filteredJobCoverageData = mappedData?.filter(
          (p) => p?.PolicyLob && p?.PolicyLob === f
        );
        if (filteredJobCoverageData && filteredJobCoverageData?.length > 0) {
          filteredJobCoverageData = filteredJobCoverageData.filter(
            (f) => f?.QLob,
          );
          if (filteredJobCoverageData && filteredJobCoverageData.length > 0) {
            policyQuestionMaster.forEach((qm) => {
              const findQuestionIsPresent = filteredJobCoverageData?.filter(
                (md) => {
                  const questionCode = md?.ChecklistQuestion?.slice(0, 3);
                  if (
                    md?.CoverageSpecification?.toLowerCase()?.includes(
                      qm?.Question?.toLowerCase(),
                    ) ||
                    questionCode?.toLowerCase() ==
                      qm?.ShortQuestion?.toLowerCase()
                  ) {
                    return true;
                  }
                  return false;
                },
              );
              if (findQuestionIsPresent?.length == 0) {
                let data = {};
                const keys = Object.keys(filteredJobCoverageData[0]);

                fileState.forEach((file) => {
                  let data = {};

                  keys.forEach((key) => {
                    if (key === "CoverageSpecification") {
                      data[key] = qm?.Question;
                    } else if (key === "QLob") {
                      data[key] = qm?.LobCode;
                    } else if (key === "PolicyLob") {
                      data[key] = qm?.LobName;
                    } else if (key === "ChecklistQuestion") {
                      data[key] = qm?.CheckListQuestion || "-";
                    }

                    //  FILE-BASED MAPPING (MAIN PART)
                    else if (key === "FileName") {
                      data[key] = file.FileName;
                    } else if (key === "DocID") {
                      data[key] = file.DocID;
                    } else if (key === "IsBaseDocument") {
                      data[key] = file.DocumentType === "Base Document";
                    } else if (key === "ExtractedValue") {
                      data[key] = "Details not available in the document";
                    }else if (key === "GroupID") {
                      data[key] = "0";
                    } else if (key === "DocumentName") {
                      data[key] = file.FileName;
                    }
                    // keep other fields safe
                    else if (filteredJobCoverageData[0]?.hasOwnProperty(key)) {
                      data[key] = null;
                    }
                    data["IsDataForQLob"] = true;
                  });
                  mappedData.push(data);
                });
              }
            });
          }
        }
      }
    });
    const acitiveLobList = checklistQuestionMaster.filter(
      (f) => f?.LobName && uniquePolicyLob?.includes(f.LobName),
    );
    console.log(uniquePolicyLob);
    console.log(acitiveLobList);
  }
  return mappedData;
};

export const getQuoteLobMasterData = async (token, brokerid) => {
  try {
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + `/api/Defaultdatum/GetLobMaster?brokerId=${brokerid}`,
      {
        headers,
      },
    );
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response?.data;
  } catch (error) {
    //error happened block
  }
};

export const setLOBSplitMasterKeys = async (token) => {
  try {
    sessionStorage.removeItem("QuoteLobSplitMasterKeys");
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      baseUrl + "/api/Defaultdatum/GetMasterLOBForSplit",
      {
        headers,
      },
    );
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    sessionStorage.setItem(
      "QuoteLobSplitMasterKeys",
      response?.data?.length > 0
        ? JSON.stringify(response?.data)
        : response?.data,
    );
    return response?.data;
  } catch (error) {
    //error happened block
  }
};
